import React, { useState, useEffect } from 'react';
import { Paper, Checkbox } from '@material-ui/core';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CustomButton from '../../../layout/customButton/CustomButton';
import styles from './UnitsPricing.module.scss';
import EditUnitPricing from './editUnitPricing/EditUnitPricing';
import Modal from '../../../layout/modal/Modal';
import { connect } from 'react-redux';
import { setAlert } from '../../../../redux/alerts/action';

const UnitsPricing = (props) => {
	const [selected, setSelected] = useState([]);
	const [elevations, setElevations] = useState([]);
	const [elevationSelected, setElevationSelected] = useState('');
	const [filteredBuildingInfo, setFilteredBuildingInfo] = useState({});
	const [editUnitPricingModal, setEditUnitPricingModal] = useState(false);
	const [editUnitPricingPage, setEditUnitPricingPage] = useState(0);
	const [unitsPricingCheckbox, setUnitsPricingCheckbox] = useState(false);
	const { buildingInfo, setAlert, filteredUnit, search } = props;

	const isUnitSelected = (name) => selected.indexOf(name) !== -1;

	useEffect(() => {
		if (buildingInfo) {
			let elevationsArr = [];
			Object.values(buildingInfo).forEach((building) => {
				building.priceList.forEach((item) => {
					if (!elevationsArr.includes(item.id)) {
						elevationsArr.push(item.id);
					}
				});
			});
			setElevations(elevationsArr);
		}
	}, [buildingInfo]);

	useEffect(() => {
		if (buildingInfo) {
			if (elevationSelected) {
				let filteredResult = Object.values(buildingInfo)
					.filter((model) => {
						return model.priceList
							.map((item) => item.id)
							.includes(elevationSelected);
					})
					.filter((model) => {
						if (filteredUnit) {
							return model.name === filteredUnit;
						} else {
							return true;
						}
					})
					.filter((model) => {
						if (search) {
							return model.name
								?.toLowerCase()
								.includes(search.toLowerCase());
						} else {
							return true;
						}
					});
				setFilteredBuildingInfo(filteredResult);
			} else {
				let filteredResult = Object.values(buildingInfo)
					.filter((model) => {
						if (filteredUnit) {
							return model.name === filteredUnit;
						} else {
							return true;
						}
					})
					.filter((model) => {
						if (search) {
							return model.name
								?.toLowerCase()
								.includes(search.toLowerCase());
						} else {
							return true;
						}
					});
				setFilteredBuildingInfo(filteredResult);
			}
		}
	}, [buildingInfo, elevationSelected, filteredUnit, search]);

	const handleSelectUnits = (event) => {
		setUnitsPricingCheckbox(!unitsPricingCheckbox);
		if (event.target.checked) {
			const newSelecteds = Object.values(buildingInfo).map(
				(item) => item.name
			);
			setSelected(newSelecteds);
			return;
		}
		setSelected([]);
	};

	const handleSelectUnit = (event, unit) => {
		const selectedIndex = selected.indexOf(unit);
		let newSelected = [];

		if (selectedIndex === -1) {
			newSelected = newSelected.concat(selected, unit);
		} else if (selectedIndex === 0) {
			newSelected = newSelected.concat(selected.slice(1));
		} else if (selectedIndex === selected.length - 1) {
			newSelected = newSelected.concat(selected.slice(0, -1));
		} else if (selectedIndex > 0) {
			newSelected = newSelected.concat(
				selected.slice(0, selectedIndex),
				selected.slice(selectedIndex + 1)
			);
		}
		setSelected(newSelected);
	};

	const handleElevationSelect = (e) => {
		setSelected([]);
		setUnitsPricingCheckbox(false);
		let data = e.currentTarget.dataset.elevation;
		if (data !== elevationSelected) {
			setElevationSelected(data);
		} else {
			setElevationSelected('');
		}
	};

	const getElevationPrice = (model, id) => {
		let price = model?.priceList.filter((price) => {
			return price.id === elevationSelected;
		});
		if (price?.length > 0) {
			return price[0].price;
		} else {
			return 0;
		}
	};

	const openEditUnitPricingModal = () => {
		if (selected.length === 0) {
			setAlert('warning', 'Please select at least one unit.');
		} else {
			setEditUnitPricingModal(true);
		}
	};

	const closeEditUnitPricingModal = () => {
		setEditUnitPricingModal(false);
		setEditUnitPricingPage(0);
	};

	return (
		<div className={styles.units_pricing}>
			<div className={styles.units_pricing_header}>
				<h3 className={styles.units_pricing_header_title}>Units</h3>
				<div>
					<CustomButton
						width={102}
						height={42}
						onClick={openEditUnitPricingModal}
					>
						Edit Units
					</CustomButton>
					<Checkbox
						className={styles.units_pricing_checkbox}
						checked={unitsPricingCheckbox}
						checkedIcon={
							<CheckBoxIcon className={styles.checkbox} />
						}
						onChange={handleSelectUnits}
					/>
				</div>
			</div>
			<h4 className={styles.select_elevation_title}>Select Elevation</h4>
			<div className={styles.select_elevation}>
				{elevations.map((elevation, item) => (
					<div
						className={`${styles.elevation_btn}  ${
							elevationSelected === elevation ? styles.active : ''
						}`}
						key={item}
						data-elevation={elevation}
						onClick={handleElevationSelect}
					>
						{elevation}
					</div>
				))}
			</div>
			{Object.values(filteredBuildingInfo).map((model) => {
				const isItemSelected = isUnitSelected(model.name);

				return (
					<Paper
						className={styles.units_pricing_card}
						key={model.name}
					>
						<div className={styles.units_pricing_card_header}>
							<h3 className={styles.units_pricing_card_title}>
								{model.name}
								{elevationSelected && ' ' + elevationSelected}
							</h3>
							<Checkbox
								className={styles.units_pricing_checkbox}
								checkedIcon={
									<CheckBoxIcon className={styles.checkbox} />
								}
								checked={isItemSelected}
								onClick={(event) =>
									handleSelectUnit(event, model.name)
								}
							/>
						</div>
						<div className={styles.units_pricing_card_body}>
							<div
								className={styles.units_pricing_card_body_price}
							>
								{elevationSelected &&
									'$ ' +
										new Intl.NumberFormat('en-US').format(
											getElevationPrice(
												model,
												elevationSelected
											)
										)}
							</div>
							<div
								className={styles.units_pricing_card_body_size}
							>
								{model.sqft} sqft
								{model.bedroomNumber &&
									` | ${model.bedroomNumber} bedrooms`}
							</div>
						</div>
					</Paper>
				);
			})}
			<div className={styles.edit_unit_pricing_modal}>
				<Modal
					show={editUnitPricingModal}
					close={closeEditUnitPricingModal}
					contentWidth={880}
				>
					<EditUnitPricing
						unitIdArr={selected}
						elevationId={elevationSelected}
						editUnitPricingPage={editUnitPricingPage}
						setEditUnitPricingPage={setEditUnitPricingPage}
					/>
				</Modal>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => ({
	buildingInfo: state.siteplanManagement.buildingInfo,
});

export default connect(mapStateToProps, { setAlert })(UnitsPricing);
